import IndexRoute from './index';
export default class IndexRootRoute extends IndexRoute {
    controllerName = 'index';
    templateName = 'index';
}
